/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ItemPrice,
  ItemPriceInput,
  ItemPrices,
  ItemPricesParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new Item Price
 */
export const createItemPrice = (
    itemPriceInput: MaybeRefOrGetter<ItemPriceInput>,
 signal?: AbortSignal
) => {
      itemPriceInput = toValue(itemPriceInput);

      return axiosClient<ItemPrice>(
      {url: `/item-prices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemPriceInput, signal
    },
      );
    }




export const getCreateItemPriceMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemPrice>>, TError,CreateItemPriceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createItemPrice>>, TError,CreateItemPriceMutationVariables, TContext> => {

const mutationKey = ['createItemPrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItemPrice>>, CreateItemPriceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createItemPrice(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemPriceMutationResult = NonNullable<Awaited<ReturnType<typeof createItemPrice>>>
    export type CreateItemPriceMutationBody = ItemPriceInput
    export type CreateItemPriceMutationError = ErrorType<ValidationError | StandardError>
    export type CreateItemPriceMutationVariables = {data: ItemPriceInput}

    /**
 * @summary Create new Item Price
 */
export const useCreateItemPrice = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemPrice>>, TError,CreateItemPriceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createItemPrice>>,
        TError,
        CreateItemPriceMutationVariables,
        TContext
      > => {
      return useMutation(getCreateItemPriceMutationOptions(options), queryClient);
    }
    /**
 * @summary Item Prices list
 */
export const itemPrices = (
    params?: MaybeRefOrGetter<ItemPricesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ItemPrices>(
      {url: `/item-prices`, method: 'GET',
        params, signal
    },
      );
    }




export const getItemPricesQueryKey = (params?: MaybeRefOrGetter<ItemPricesParams>,) => {
    return [
    'item-prices', ...(params ? [params] : [])
    ] as const;
    }


export const getItemPricesQueryOptions = <TData = Awaited<ReturnType<typeof itemPrices>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ItemPricesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemPrices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getItemPricesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof itemPrices>>> = ({ signal }) => itemPrices(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof itemPrices>>, TError, TData>
}

export type ItemPricesQueryResult = NonNullable<Awaited<ReturnType<typeof itemPrices>>>
export type ItemPricesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Item Prices list
 */

export function useItemPrices<TData = Awaited<ReturnType<typeof itemPrices>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ItemPricesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemPrices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getItemPricesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Item price destroy
 */
export const destroyItemPrice = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/item-prices/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyItemPriceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyItemPrice>>, TError,DestroyItemPriceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyItemPrice>>, TError,DestroyItemPriceMutationVariables, TContext> => {

const mutationKey = ['destroyItemPrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyItemPrice>>, DestroyItemPriceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyItemPrice(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyItemPriceMutationResult = NonNullable<Awaited<ReturnType<typeof destroyItemPrice>>>

    export type DestroyItemPriceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyItemPriceMutationVariables = {id: string}

    /**
 * @summary Item price destroy
 */
export const useDestroyItemPrice = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyItemPrice>>, TError,DestroyItemPriceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyItemPrice>>,
        TError,
        DestroyItemPriceMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyItemPriceMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Item Price
 */
export const itemPrice = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ItemPrice>(
      {url: `/item-prices/${id}`, method: 'GET', signal
    },
      );
    }




export const getItemPriceQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'item-prices',id
    ] as const;
    }


export const getItemPriceQueryOptions = <TData = Awaited<ReturnType<typeof itemPrice>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemPrice>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getItemPriceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof itemPrice>>> = ({ signal }) => itemPrice(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof itemPrice>>, TError, TData>
}

export type ItemPriceQueryResult = NonNullable<Awaited<ReturnType<typeof itemPrice>>>
export type ItemPriceQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Item Price
 */

export function useItemPrice<TData = Awaited<ReturnType<typeof itemPrice>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof itemPrice>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getItemPriceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Item Price
 */
export const updateItemPrice = (
    id: MaybeRefOrGetter<string>,
    itemPriceInput: MaybeRefOrGetter<ItemPriceInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
itemPriceInput = toValue(itemPriceInput);

      return axiosClient<ItemPrice>(
      {url: `/item-prices/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: itemPriceInput, signal
    },
      );
    }




export const getUpdateItemPriceMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemPrice>>, TError,UpdateItemPriceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItemPrice>>, TError,UpdateItemPriceMutationVariables, TContext> => {

const mutationKey = ['updateItemPrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItemPrice>>, UpdateItemPriceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateItemPrice(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemPriceMutationResult = NonNullable<Awaited<ReturnType<typeof updateItemPrice>>>
    export type UpdateItemPriceMutationBody = ItemPriceInput
    export type UpdateItemPriceMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateItemPriceMutationVariables = {id: string;data: ItemPriceInput}

    /**
 * @summary Update Item Price
 */
export const useUpdateItemPrice = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemPrice>>, TError,UpdateItemPriceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateItemPrice>>,
        TError,
        UpdateItemPriceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateItemPriceMutationOptions(options), queryClient);
    }
